import { render } from "./ColorCustomizer.vue?vue&type=template&id=33a90b30"
import script from "./ColorCustomizer.vue?vue&type=script&lang=js"
export * from "./ColorCustomizer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__